import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { at } from 'lodash';
import dayjs from 'dayjs';

function DatePickerField(props: any) {
  const [field, meta] = useField(props);
  const formikProps: any = useFormikContext();
  const { label, dateAdapter = AdapterDayjs } = props;

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
    if (
      touched &&
      props.required &&
      (!formikProps.values[field.name] || formikProps.values[field.name] === '')
    ) {
      return 'Campo requerido';
    }
    return '';
  }

  return (
    <LocalizationProvider dateAdapter={dateAdapter} adapterLocale="es">
      <DatePicker
        label={label}
        value={dayjs(formikProps.values[field.name])}
        onChange={(value) => {
          formikProps.setFieldValue(field.name, value?.format('YYYY-MM-DD'));
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            error: Boolean(
              (meta.touched && meta.error) ||
              (meta.touched &&
                props.required &&
                (!formikProps.values[field.name] || formikProps.values[field.name] === ''))
            ),
            helperText: _renderHelperText(),
          },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
}

DatePickerField.defaultProps = {
  label: '',
  name: '',
  dateAdapter: AdapterDayjs,
  views: ['year', 'month', 'day'],
};

DatePickerField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  dateAdapter: PropTypes.any,
  views: PropTypes.array,
};

export default DatePickerField;
